import type { AuthPermissionUser } from '../../services/authPermissions';

export function canManageGlobalNotificationSettings(user: AuthPermissionUser | null | undefined): boolean {
  return user?.role === 'ADMIN';
}

export function canManageNotificationRecipientPool(user: AuthPermissionUser | null | undefined): boolean {
  return canManageGlobalNotificationSettings(user);
}
